<template>
	<SubmissionFetchError
		v-if="errorMessage"
		:message="errorMessage"
	/>
	<PaymentForm
		v-else
		:plan-id="planId"
		:purchase-amount="purchaseAmount"
		@payment-submitted="submit"
	/>
</template>

<script setup lang="ts">
import PaymentForm from '@/components/home/SubmissionStatuses/ResubmissionModals/PaymentForm.vue'
import useResubmissionHelper from '@/components/home/SubmissionStatuses/ResubmissionModals/ResubmissionHelper'
import SubmissionFetchError from '@/components/home/SubmissionStatuses/SubmissionFetchError.vue'
import { useEverplansResubmissionService } from '@/services/everplansResubmission'
import type { EverplansPayment } from '@/types'

export type FixPaymentProps = { planId: string; purchaseAmount?: number }

const props = defineProps<FixPaymentProps>()
const emit = defineEmits(['closeModal'])

const { upgradeEverplansSubscription } = useEverplansResubmissionService()

const { errorMessage, setError } = useResubmissionHelper()

const submit = async (everplansPayment: EverplansPayment) => {
	try {
		await upgradeEverplansSubscription(props.planId, everplansPayment)
		emit('closeModal')
	} catch (e) {
		setError(e)
	}
}
</script>

<style scoped></style>
